/**
 * @generated SignedSource<<4ea67db83ac4af88c9f92bf0bf81aac3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped$data = {
  readonly __typename: "WidgetTodoOverviewContentMediumGrouped";
  readonly id: string;
  readonly subjectGroups: ReadonlyArray<{
    readonly subject: {
      readonly " $fragmentSpreads": FragmentRefs<"TodoSubject_TodoSubject">;
    } | null;
    readonly todos: ReadonlyArray<{
      readonly id: string;
      readonly ordinal: string;
      readonly status: TodoStatus;
      readonly " $fragmentSpreads": FragmentRefs<"TodoOverviewListItemMedium_Todo">;
    }>;
  }>;
  readonly subscriptionKey: string;
  readonly " $fragmentType": "WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped";
};
export type WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped$key = {
  readonly " $data"?: WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subscriptionKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoSubjectGroup",
      "kind": "LinkedField",
      "name": "subjectGroups",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TodoSubject",
          "kind": "LinkedField",
          "name": "subject",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TodoSubject_TodoSubject"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Todo",
          "kind": "LinkedField",
          "name": "todos",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ordinal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TodoOverviewListItemMedium_Todo"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTodoOverviewContentMediumGrouped",
  "abstractKey": null
};
})();

(node as any).hash = "dd1f9b5f3744021268a1489cd3ac3c66";

export default node;
